import {NavLink} from 'react-router-dom';
import {
    Button,
    Card,
    Group,
    Stack,
    Text,
    Title,
} from '@mantine/core';
import {I18n} from 'aws-amplify/utils';

import {dnsRecordsConfig} from '../../dns-records';

// FNP-1288 — the front door to the records module, filling the reservation the
// zone detail page held for FNP-1192.
//
// ⚠️ A LINK INTO THE NESTED ROUTE, NOT THE TABLE INLINE, and the choice is
// forced by what the records module actually is rather than by preference.
//
// `DnsRecordsTable` renders rows and nothing else. Every write control — Add,
// Delete, Filter, Reload — lives in the module's `IndexPageHeader`, and its
// breadcrumb (Home → Zones → this zone → Records) is built for a page. Dropping
// the bare table into this column would show records with no way to add one,
// which is the same "deployed but unreachable" defect this ticket exists to
// fix, one level down. Reproducing the toolbar here would fork a second copy of
// the module's page.
//
// The link carries `connectionId` because `listDnsRecords(connectionId:,
// zoneId:)` needs both and the route holds only the zone id. `recordsPath` is
// the module's own builder, so this shares the records page's contract instead
// of inventing a second one.
export const RecordsPanel = (
    {
        zoneId,
        connectionId,
    }: {
        zoneId: string,
        connectionId?: string,
    },
) => {
    return (
        <Card withBorder={true} padding={'lg'} radius={'md'}>
            <Stack gap={'md'}>
                <Stack gap={4}>
                    <Title order={4}>{I18n.get('Records')}</Title>
                    <Text size={'sm'} c={'dimmed'}>
                        {I18n.get('The DNS records this zone publishes — the addresses, aliases and nameserver delegations served for it.')}
                    </Text>
                </Stack>
                <Group>
                    <Button
                        component={NavLink}
                        to={dnsRecordsConfig.recordsPath(zoneId, connectionId)}
                        variant={'light'}
                    >
                        {I18n.get('View records')}
                    </Button>
                </Group>
            </Stack>
        </Card>
    );
};
